import { useQuery, useMutation, useQueryClient } from 'react-query'

import { getLiveId } from '../../../../global/blocs/roomInfo'
import { endPoll, getPolls, startPoll } from '../api/polls'
import { type Poll, pollMapper } from '../models/poll'

/** Get polls for webinar */
export function usePollsQuery() {
  return useQuery(['polls'], async (): Promise<Poll[]> => {
    const mapper = pollMapper()
    return (await getPolls(getLiveId())).map(mapper.fromDto)
  })
}

export function useInvalidatePollsQuery(id: string): () => Promise<void> {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries(['polls', id])
}

export function useStartPollMutation(pollId: number) {
  return useMutation({
    mutationKey: ['start-poll', pollId],
    mutationFn: () => startPoll(pollId),
  })
}

export function useEndPollMutation(pollId: number) {
  return useMutation({
    mutationKey: ['end-poll', pollId],
    mutationFn: () => endPoll(pollId),
  })
}
